<template>
  <div class="complaintRecord">
    <label>申诉记录</label>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="appeal_no" label="申诉单号"></el-table-column>
      <el-table-column prop="test_class_title" label="申诉测试"></el-table-column>
      <el-table-column prop="appeal_content" label="申诉内容" width="240">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper" style="max-height:70px;overflow:auto">
            <div v-if="scope.row.appeal_content[0]">
              <span>首次申诉：</span>
              <br />
              <p>{{scope.row.appeal_content[0]}}</p>
            </div>
            <div v-if="scope.row.appeal_content[1]">
              <span>二次申诉：</span>
              <br />
              <p>{{scope.row.appeal_content[1]}}</p>
            </div>
            <!-- <p class="m-content overflow-line" id="J_description">{{introduce}}</p>
            <button
              type="button"
              class="btn-more"
              v-if="isShowMore"
              id="J_btnmore"
              @click="showmoreDesc($event)"
            >查看更多</button> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="appeal_status" label="申诉结果" width="200">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium" v-if="scope.row.appeal_status==0">申诉已提交，请等待</el-tag>
            <el-tag size="medium" v-if="scope.row.appeal_status==1">审核中</el-tag>
            <el-tag size="success" v-if="scope.row.appeal_status==2">审核结束,成绩予以修改</el-tag>
            <el-tag size="danger" v-if="scope.row.appeal_status==3">审核结束,成绩不予以修改</el-tag>
            <el-tag size="medium" v-if="scope.row.appeal_status==4">第二次申诉已提交，请等待</el-tag>
            <el-tag size="medium" v-if="scope.row.appeal_status==5">第二次申诉审核中</el-tag>
            <el-tag size="success" v-if="scope.row.appeal_status==6">第二次审核通过</el-tag>
            <el-tag size="danger" v-if="scope.row.appeal_status==7">已进行两次申诉，无法再次申诉</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="appeal_reply,manager_reply" label="处理意见"  width="240">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper" style="max-height:70px;overflow:auto">
            <div v-if="scope.row.appeal_reply">
              <span>首次申诉：</span>
              <br />
              <p>{{scope.row.appeal_reply}}</p>
            </div>
            <div v-if="scope.row.manager_reply">
              <span>二次申诉：</span>
              <br />
              <p>{{scope.row.manager_reply}}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            v-if="scope.row.appeal_status==3"
            @click="handleClick(scope.row)"
          >二次申诉</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="二次申诉"
      :visible.sync="dialogFormVisible"
      class="complaintDialog"
      :width="dialogFormVisibleWidth"
    >
      <el-form :model="form">
        <el-form-item label="申诉内容" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.desc" placeholder="最多输入100个字" @input="descInput"  maxlength="100"></el-input>
          <p style="margin-top:5px">{{remnant}}/100</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTable">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAthleteTestData,
  UpdateAthleteSSAppeal
} from "@/api/admin/athletes.js";
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["screenWidth"])
  },
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      form: {
        desc: ""
      },
      formLabelWidth: "120px",
      complaintContent: {},
      status: "",
      remnant: 100,
      dialogFormVisibleWidth: "30%"
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getAthleteTestData({}).then(data => {
        var list = data.data.result;
        this.tableData=[];
        if (list) {
          for (var i = 0; i < list.items.length; i++) {
            list.items[i].appeal_content = list.items[i].appeal_content.split(
              "/"
            );
            this.tableData.push(list.items[i]);
          }
        }
      });
    },
    // 申诉文字控制
    descInput() {
      var txtVal = this.form.desc.length;
      this.remnant = 100 - txtVal;
      if (this.remnant < 0) {
        this.remnant = 0;
      }
    },
    // 申诉
    handleClick(row) {
      if (this.screenWidth < 1025) {
        this.dialogFormVisibleWidth = "60%";
      }
      if (this.screenWidth < 768) {
        this.dialogFormVisibleWidth = "80%";
      }
      this.complaintContent.id = row.id;
      this.dialogFormVisible = true;
    },
    // 二次申诉提交
    submitTable() {
      this.complaintContent.appeal_content = this.form.desc;
      if (this.complaintContent.appeal_content.length > 100) {
        this.$message({
          message: "申诉内容请控制在100字以内",
          type: "warning"
        });
      } else {
        this.dialogFormVisible = false;
        UpdateAthleteSSAppeal(Object.assign(this.complaintContent)).then(
          data => {
            var list = data.data.result;
            if (list.isSuccess == true) {
              this.$message({
                message: "您的申诉已提交，请等待",
                type: "success"
              });
              this.getList();
            } else {
              this.$message.error("申诉提交失败");
            }
          }
        );
      }
    }
    // contentFormat(str){
    //   return str.split("/")
    // }

    // handleClick(row) {
    //   this.status = row.appeal_status;
    //   this.dialogFormVisible = true;
    //   UpdateAthleteSSAppeal({}).then(data => {
    //     var list = data.data.result;
    //     if (list) {
    //       //   this.tableData = list.items;
    //     }
    //   });
    // }
  }
};
</script>

<style lang="less" scoped>
.complaintRecord {
  label {
    font-size: 18px;
    line-height: 47px;
  }
}
</style>
